import jsPDF from "jspdf";
import html2canvas from "html2canvas";
function formatDateWithSuffix(dateInput) {
  const d = new Date(dateInput);

  const day = d.getDate();
  const month = d.toLocaleString('en-IN', { month: 'long' });
  const year = d.getFullYear();

  const getSuffix = (day) => {
    if (day >= 11 && day <= 13) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  };

  return `${day}${getSuffix(day)} ${month} ${year}`;
}
const generateCertificatePDF = async ({
  name,
  testDate = "",
  result = "Pass"   // "Pass" or "Fail"
}) => {

  const today = new Date();
  const formattedDate = formatDateWithSuffix(today);

  let formattedTestDate = "";
  if (testDate) {
    const parsedDate = new Date(testDate);
    formattedTestDate = !isNaN(parsedDate)
    ? formatDateWithSuffix(parsedDate)
    : testDate;
  }

  const isPass = result === "Pass";

  // ── Shared styles ─────────────────────────────────────────────
  const bodyStyle = `
    font-family: 'Times New Roman';
    font-size: 14pt;
    line-height: 1.75;
    color: #000;
    text-align: justify;
  `;

  // ── PASS letter body ──────────────────────────────────────────
  const passBody = `
    <p style="margin:0 0 6px 0;">
      <span style="text-decoration:underline;"><strong>Subject: Welcome to Mensa India</strong></span>
    </p>

    <p style="margin:10px 0;">Dear ${name},</p>

    <p style="margin:10px 0;">
      This is in regard to the Prior Evidence submitted to Mensa India.&nbsp; I am delighted to
      inform you that our team of Mensa India National Supervisory Psychologists have evaluated
      the evidence you have submitted and concluded that your scores qualify you for Mensa India
      Membership.
    </p>

    <p style="margin:10px 0;">
      &nbsp;You have the unique privilege of having the opportunity to join a dynamic and vibrant
      organization with over 145,000 members spread over 100 countries around the world and
      around 4000 members in India.
    </p>

    <p style="margin:10px 0; text-indent: 40px;">
      You will soon receive an invitation to join the Mensa India Chapter closest to you.
      However, your valid membership is transferable to any other chapter in India without
      additional fees. It is therefore very important that we keep a full set of records
      pertaining to your membership. We will also be issuing you a membership card that will be
      proof of your having qualified for and having joined Mensa. As your travels take you to
      different parts of India or abroad and you wish to join the local Mensa Chapter, your ID
      card &amp; membership number will enable you to join the local chapter. Furthermore, most
      of the 100 + National Mensa Chapters worldwide are likely to extend to you the courtesy of
      treating you as a guest member and will invite you to join their activities when you are in
      their country. Thus, it is very much to your advantage to formally become a Member of
      Mensa India and obtain your membership card.
    </p>

    <p style="margin:10px 0;">
      Welcome again to Mensa India and I look forward to welcoming you soon to our society.
    </p>
    <div style="margin-top:25px;">
    <p style="margin:14px 0 2px 0;">With best wishes,</p>
    <p style="margin:0;">For Mensa India</p>
  `;

  // ── FAIL letter body ──────────────────────────────────────────
  const failBody = `
    <p style="margin:10px 0;">Dear ${name},</p>

    <p style="margin:10px 0;">
      This is in regard to the Prior Evidence submitted to Mensa India.&nbsp; I regret to inform
      you that our team of Mensa India National Supervisory Psychologists have evaluated the
      evidence you have submitted and concluded that your scores does not qualify you for Mensa
      India Membership.
    </p>

    <p style="margin:10px 0;">
      I would like to mention that IQ tests measure a narrow range of intelligence, which is
      generally defined as &#8220;General Intelligence&#8221;. Apart from this, one can possess
      many different kinds of intelligences. You may not have qualified for Mensa Membership but
      you may still be brilliant in so many other fields such as music, arts, sports, dance,
      writing and other forms of giftedness. You may like to explore, and focus on, activities
      that you have passion for.
    </p>

    <p style="margin:14px 0 2px 0;">With best wishes,</p>
    <p style="margin:0;">For Mensa India</p>
  `;

  // ── Address block (Pass vs Fail layout differs slightly) ──────
  // Pass:  To,         Date: DD/MM/YYYY  (table row, name below on new line)
  // Fail:  To,         Date: DD/MM/YYYY  (same row, name directly below To)
  const addressBlock = `
    <table style="width:100%; margin-bottom:${isPass ? '14px' : '10px'}; border:none; border-collapse:collapse;">
      <tr>
        <td style="vertical-align:top; padding:0;">
          To,<br>
          ${name},
        </td>
        <td style="text-align:right; vertical-align:top; padding:0;">
          Date: ${formattedDate}
        </td>
      </tr>
    </table>
    ${isPass ? `<p style="margin:0 0 10px 0;">&nbsp;</p>` : ''}
  `;

  // ── Build full element ────────────────────────────────────────
  const element = document.createElement("div");
  element.style.cssText = `
    width: 794px;
    background: #ffffff;
    font-family: 'Times New Roman';
    font-size: 14pt;
  `;

  element.innerHTML = `
    <!-- ═══ HEADER ═══ -->
    <div style={{
      display: flex;
      align-items: center;
      padding: 14px 24px 14px 18px;
      min-height: 90px;
      background: #002668;
    }}>
      
      <div style={{ flexShrink: 0 }}>
        <img
          src="/Mensa_letterhead.jpg"
          style={{ height: "72px", display: "block" }}
          alt="logo"
        />
      </div>
    </div>
    <!-- ═══ BODY ═══ -->
    <div style="
      padding: 30px 54px 40px 54px;
      ${bodyStyle}
    ">
      <!-- To / Date -->
      ${addressBlock}

      <!-- Letter content -->
      ${isPass ? passBody : failBody}

      <div style="margin-top:40px;">
        <!-- Signature gap -->
        <div style="height: 100px;"></div>
        <!-- Signatory -->
        <p style="margin:0 0 4px 0;">Dr. Meenakshi Gokhale</p>
        <p style="margin:0;">National Supervisory Psychologist</p>
      </div>
    </div>
  `;

  // Temporarily attach to DOM (off-screen)
  element.style.position = "absolute";
  element.style.left = "-9999px";
  element.style.top = "0";
  document.body.appendChild(element);

  // Wait for logo image to load
  const img = element.querySelector("img");
  await new Promise((resolve) => {
    if (img.complete) { resolve(); return; }
    img.onload = resolve;
    img.onerror = resolve; // continue even if logo missing
  });

  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    allowTaint: true,
    backgroundColor: "#ffffff",
    logging: false,
  });

  const imgData = canvas.toDataURL("image/png");

  // A4: 210 x 297 mm
  const pdf = new jsPDF("p", "mm", "a4");
  const pdfWidth = 210;
  const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

  // If content taller than one A4 page, split across pages
  const pageHeight = 297;
  if (pdfHeight <= pageHeight) {
    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
  } else {
    let yOffset = 0;
    let remaining = pdfHeight;
    let isFirstPage = true;

    while (remaining > 0) {
      const sliceHeight = Math.min(pageHeight, remaining);
      const srcY = (yOffset / pdfHeight) * canvas.height;
      const srcH = (sliceHeight / pdfHeight) * canvas.height;

      const sliceCanvas = document.createElement("canvas");
      sliceCanvas.width = canvas.width;
      sliceCanvas.height = srcH;
      const ctx = sliceCanvas.getContext("2d");
      ctx.drawImage(canvas, 0, srcY, canvas.width, srcH, 0, 0, canvas.width, srcH);

      const sliceData = sliceCanvas.toDataURL("image/png");

      if (!isFirstPage) pdf.addPage();
      pdf.addImage(sliceData, "PNG", 0, 0, pdfWidth, sliceHeight);

      yOffset += sliceHeight;
      remaining -= sliceHeight;
      isFirstPage = false;
    }
  }

  const filename = `${name.replace(/\s+/g, "_")}.pdf`;
  pdf.save(filename);

  document.body.removeChild(element);
};

export default generateCertificatePDF;